<section class="iga-coordinator">
  <div class="iga-coordinator__header">
    <div class="iga-coordinator__header-row">
      <div class="iga-coordinator__title-wrapper">
        <h2 class="iga-coordinator__title">IGA Coordinator</h2>
        @if (canEdit) {
          <button
            type="button"
            class="iga-coordinator__edit-btn"
            (click)="toggleEdit()"
            [disabled]="isSaving"
            aria-label="Edit IGA Coordinator"
          >
            <span class="material-symbols-outlined" aria-hidden="true">edit</span>
          </button>
        }
      </div>
      @if (isEditing) {
        <div class="iga-coordinator__actions">
          <app-az-button
            label="Discard"
            variant="default"
            [showIcon]="false"
            [disabled]="isSaving"
            (click)="discard()"
          />
          <app-az-button
            label="Save Changes"
            variant="primary"
            [showIcon]="false"
            [disabled]="!hasChanges || isSaving"
            (click)="saveChanges()"
          />
        </div>
      }
    </div>
    <p class="iga-coordinator__subtitle">
      This member is responsible for approving the Letter of Adherence for this legal entity.
    </p>
  </div>

  <div class="iga-coordinator__fields">
    <div class="iga-coordinator__field">
      <app-az-selector
        label="IGA Coordinator:"
        [options]="coordinatorOptions"
        [selectedValue]="coordinatorSelectorValue"
        [disabled]="!isEditing || isLoadingOptions || isSaving"
        (selectionChange)="onCoordinatorChange($event)"
      />
    </div>
  </div>
</section>

<app-status-change-modal
  class="iga-coordinator__signing-confirmation"
  [isOpen]="showSigningConfirmation"
  [initialState]="'custom-confirm'"
  [title]="'Signing Process in Progress'"
  [customMessage]="'This Legal Entity has an active signing process. Changing the IGA Coordinator will cancel the current signing request and restart the process with the newly selected coordinator.'"
  [customNoButtonLabel]="'Cancel'"
  [customYesButtonLabel]="'Continue'"
  (customNo)="cancelSigningConfirmation()"
  (customYes)="confirmSigningChange()"
  (closed)="cancelSigningConfirmation()"
/>

<app-status-change-modal
  [isOpen]="showSigningError"
  [initialState]="'error'"
  [title]="'Warning'"
  [resultTitle]="signingErrorTitle"
  [errorMessage]="signingErrorMessage"
  [resultVariant]="'error'"
  (closed)="dismissSigningError()"
/>
